import { render, staticRenderFns } from "./LoadProfileTagManagerModal.vue?vue&type=template&id=1fca4aea&scoped=true"
import script from "./LoadProfileTagManagerModal.vue?vue&type=script&lang=js"
export * from "./LoadProfileTagManagerModal.vue?vue&type=script&lang=js"
import style0 from "./LoadProfileTagManagerModal.vue?vue&type=style&index=0&id=1fca4aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca4aea",
  null
  
)

export default component.exports